import type { IconSvgObject } from './types';

const ArrowLeft03Icon: IconSvgObject = [
  ["path", { d: "M4 6L4 18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.00012 12.0005L20.0001 12.0005", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 8C12 8 8.00001 10.946 8 12C7.99999 13.0541 12 16 12 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrowLeft03Icon;
